import DocumentPreview from './DocumentPreview';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import leadActions from '@/redux/lead/actions';

const mapStateToProps = ({ lead }, ownProps) => {
  return {
    lead,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchDocument: leadActions.fetchDocument,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DocumentPreview);
